const details = [
  { label: "Numer oferty", value: "10" },
  { label: "Typ transakcji", value: "Sprzedaż" },
  { label: "Cena", value: "849 000 EUR" },
  { label: "Powierzchnia", value: "236,5 m²" },
  { label: "Cena za m²", value: "3 589,85 EUR / m²" },
  { label: "Liczba pokoi", value: "7" },
  { label: "Powierzchnia działki", value: "9 600 m²" },
  { label: "Rok budowy", value: "2009" },
  { label: "Rynek", value: "wtórny" },
  { label: "Typ ogrodzenia", value: "metalowe" },
  { label: "Liczba kondygnacji", value: "2" },
  { label: "Forma własności", value: "własność" },
  { label: "Kanalizacja", value: "miejska" },
];

export default function PropertyDetails() {
  return (
    <div className="space-y-8">
      {/* Description */}
      <div>
        <h4 className="text-lg font-bold text-gray-900 mb-4 flex items-center gap-2">
          <span className="w-1 h-5 bg-amber-600 rounded-full inline-block" />
          Opis oferty
        </h4>
        <div className="text-sm text-gray-700 leading-relaxed">
          <p>
            Budynek mieszkany o charakterze rezydencyjnym położony w Bydlinie w zakolu rzeki Słupi
            (ok 180 m linii brzegowej rzeki) w spokojnej i cichej okolicy.
          </p>
          <p className="mt-2">W odległości 9 km od Ustki i Słupska.</p>
          <p className="mt-2">
            Cała nieruchomość jest ogrodzona z indywidualną bramą wjazdową z zachowaniem wymaganych środków bezpieczeństwa.
          </p>
          <p className="mt-2">
            Wysoki standard materiałów wykończeniowych, min: płytki IMOLA oraz Versace i dębowy parkiet.
          </p>
          <p className="mt-2">
            Drewniana stolarka okienna i drzwiowa firmy M&amp;S, z zastosowaniem dodatkowych wyciszeń,
            zrealizowana na indywidualne zamówienie inwestora.
          </p>
          <p className="mt-2">
            Na terenie rezydencji znajduje się budynek gospodarczy, garaż z miejscem parkingowym na dwa samochody,
            oraz tzw. &quot;rybaczówka&quot; o charakterze mieszkalnym z dwoma niezależnymi mieszkaniami.
          </p>
          <p className="mt-2">
            Nieruchomość wykorzystywana jest przez zagraniczne firmy korporacyjne dla ich kadry zarządzającej.
          </p>
          <p className="mt-4 text-xs text-gray-400 italic border-t border-gray-100 pt-4">
            Treść niniejszego ogłoszenia nie stanowi oferty handlowej w rozumieniu Kodeksu Cywilnego.
            Oferta wysłana z programu IMO dla pośredników.
          </p>
        </div>
      </div>

      {/* Info table */}
      <div>
        <h4 className="text-lg font-bold text-gray-900 mb-4 flex items-center gap-2">
          <span className="w-1 h-5 bg-amber-600 rounded-full inline-block" />
          Informacje
        </h4>
        <div className="rounded-lg border border-gray-100 overflow-hidden">
          {details.map((item, i) => (
            <div
              key={i}
              className={`flex items-center justify-between px-5 py-3 text-sm ${
                i % 2 === 0 ? "bg-stone-50" : "bg-white"
              }`}
            >
              <span className="text-gray-500">{item.label}</span>
              <strong className="text-gray-800 font-semibold text-right">{item.value}</strong>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
